<script setup lang="ts">
import { isJust, toDomAttr, type Maybe } from "../../lib/maybe";

defineProps<{
  label: string;
  forId: Maybe<string>;
}>();
</script>

<template>
  <!-- Bare <label> + nested buttons also activates the first button. -->
  <label v-if="isJust(forId)" class="zw-field" :for="toDomAttr(forId)">
    <span class="zw-field-label">{{ label }}</span>
    <slot />
  </label>
  <div v-else class="zw-field">
    <span class="zw-field-label">{{ label }}</span>
    <slot />
  </div>
</template>

<style>
.zw-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-family: var(--font-ui);
  color: var(--text-muted);
}

.zw-field-label {
  display: block;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
</style>
